import { animate, Component, state, style, transition, trigger } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { SearchPage } from '../search/search';

@Component({
    selector: 'page-home',
    templateUrl: 'home.html',
    animations: [
        trigger('heroState', [
            state('inactive', style({
                top: '50%',
                opactity: '1'
            })),
            state('active', style({
                top: '0',
                opactity: '0'
            })),
            transition('inactive => active', animate('500ms ease-in')),
            transition('active => inactive', animate('100ms ease-out'))
        ]),

        trigger('posSearchbar', [
            state('center', style({
                top: '50%'
            })),
            state('top', style({
                top: '0'
            })),
            transition('center => top', animate('250ms ease-in')),
            transition('top => center', animate('50ms ease-out'))
        ])
    ]
})

export class HomePage {

    storedSearchCategory: string;
    position: any;

    constructor(public navCtrl: NavController, public navParams: NavParams) {
        this.position = 'center';
    }

    /**
     * Loads stored search category from localStorage
     */
    ionViewDidEnter() {
        this.storedSearchCategory = localStorage.getItem('storedSearchCategory') || 'paper';
    }

    /** Pushes selectedSearchCategory to nav controller */
    goToSearch() {
        this.navCtrl.push(SearchPage, {'selectedSearchCategory': this.storedSearchCategory});
    }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts